import { hasClass } from '../has-class';

export function firstByClass(
	elements: HTMLElement[],
	className: string
): HTMLElement {
	for (const parent of elements as HTMLElement[]) {
		if (hasClass(parent, className)) {
			return parent;
		}
	}

	return null;
}
